import { create } from 'zustand'

export interface PendingNavigation {
  formName: string
  to: string | number
  options?: Record<string, unknown>
}

interface NavigationState {
  unsavedFormChange: { formName: string; onSave: () => Promise<void> | void } | null
  pendingNavigation: PendingNavigation | null
  setUnsavedFormChange: (
    change: { formName: string; onSave: () => Promise<void> | void } | null,
  ) => void
  setPendingNavigation: (nav: PendingNavigation | null) => void
}

export const useNavigationStore = create<NavigationState>(set => ({
  unsavedFormChange: null,
  pendingNavigation: null,
  setUnsavedFormChange: change => set({ unsavedFormChange: change }),
  setPendingNavigation: nav => set({ pendingNavigation: nav }),
}))
